import axios from 'axios'
import { UrlBase } from './config'

const providers = {}

providers.getProviders = (token) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'providers'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

export default providers
